// @flow
export type SignUpOrderActionType =
  | {|
      type: 'SIGNUP_SET_ORDER_UUID',
      payload: {|
        state: null,
        uuid: ?string,
      |},
    |}
  | {|
      type: 'SIGNUP_SET_ORDER_STATE_FOR_UUID',
      payload: {|
        state: ?string,
        uuid: ?string,
      |},
    |};

export const setOrderUuid = (uuid: ?string): SignUpOrderActionType => {
  return {
    type: 'SIGNUP_SET_ORDER_UUID',
    payload: {
      state: null,
      uuid,
    },
  };
};

export const setOrderStateForUuid = (state: ?string, uuid: ?string): SignUpOrderActionType => {
  return {
    type: 'SIGNUP_SET_ORDER_STATE_FOR_UUID',
    payload: {
      state,
      uuid,
    },
  };
};
